import { CoinwarzResponse, NetworkStats } from './types';
import { COINWARZ_COINS, API_ENDPOINTS } from './constants';

export async function fetchCoinwarzData(coin: string): Promise<CoinwarzResponse | null> {
  if (!COINWARZ_COINS[coin as keyof typeof COINWARZ_COINS]) {
    return null;
  }

  try {
    const response = await fetch(
      `${API_ENDPOINTS.COINWARZ}/profitability/${COINWARZ_COINS[coin as keyof typeof COINWARZ_COINS]}?apikey=${import.meta.env.VITE_COINWARZ_API_KEY}`,
      {
        headers: {
          'Accept': 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(`Coinwarz API responded with status: ${response.status}`);
    }

    return await response.json() as CoinwarzResponse;
  } catch (error) {
    console.warn('Error fetching Coinwarz data:', error);
    return null;
  }
}

export function convertCoinwarzToNetworkStats(data: CoinwarzResponse): NetworkStats {
  return {
    hashrate_24h: data.Data.NetworkHashrate,
    difficulty: data.Data.Difficulty,
    block_reward: data.Data.BlockReward,
    block_time: data.Data.BlockTime
  };
}